export const appBaseUrl = 'https://alorwaapi.azurewebsites.net'
//export const appBaseUrl = 'https://localhost:44383'